<template>

  <article class="content-section home-section">
    <header class="section-header">
      <h3 class="title" style="font:normal 20px/28px var(--kb-font-KBFGDisplayB)">목표 달성 현황</h3>
      <div class="mysetting" style="padding-top: 0px;">
        <button class="btn-xs kb-btn-setting-pc" @click="licRegModal=!licRegModal">
          <i class="icon-goal" style=""></i>
          <span class="text">목표설정</span>
        </button>
      </div>
    </header>
    <div class="section-body">
      <swiper v-if="sslLicenseList.length > 0"
              class="hrdcloud-swiper"
              :modules="modules"
              slides-per-view="auto"
              :speed="750"
              :navigation="{
                      prevEl: '.swiper-btn-prev',
                      nextEl: '.swiper-btn-next'
                  }"
      >
        <swiper-slide  v-for="(roadmap,idx) in sslLicenseList" :key="idx" class="roadmap-swiper" style="width: 220px !important;margin-left:12px">
          <SSLLicStatusCard
              :data="roadmap"
              @search="doSearch"
          />
        </swiper-slide>
        <button class="swiper-btn-prev">
          <i class="icon-arrow">prev</i>
        </button>
        <button class="swiper-btn-next">
          <i class="icon-arrow">next</i>
        </button>
      </swiper>
      <LoadingDiv v-else />
    </div>
  </article>

  <SSLLicRegModal
    v-if="licRegModal"
    v-model:toggle="licRegModal"
    :lrn-trgt-grp-mst-sn="lrnTrgtGrpMstSn"
    @completed="getSocLcsnStat"
  >

  </SSLLicRegModal>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import LoadingDiv from '@/components/common/LoadingDiv.vue';
import SSLLicStatusCard from '@/components/ssl/lcsn/SSLLicStatusCard.vue';
import {sslLicenseSetup} from "@/assets/js/modules/ssl/setup/ssl-license-setup";
import SSLLicRegModal from "@/components/ssl/lcsn/SSLLicRegModal.vue";
export default {
  name: 'SSLLicStatus',
  components: {
    SSLLicRegModal,
    SSLLicStatusCard, LoadingDiv, Swiper, SwiperSlide},
  props: {
    mainList: Array,
    lrnTrgtGrpMstSn: Number,
  },
  emits: ['search'],
  setup: sslLicenseSetup,
};
</script>
<style>
.mysetting .kb-btn-setting-pc {width:120px; height:42px; margin-right:10px;display:inline-flex;align-items:center;justify-content:center;border-radius: 16px;background-color:#F7F4F0;}
.mysetting .kb-btn-setting-pc .icon-goal {background-image:url(../../../assets/lxp/images/talentboard/ic_goal.svg);margin-right:4px;}
.mysetting .kb-btn-setting-pc .text {color:var(--kb-dark-brown);font:normal 12px var(--kb-font-KBFGTextB);}


</style>